import React from "react";
import { Routes, Route } from "react-router-dom";

import Dashboard from "../pages/Dashboard/Dashboard";

import AuthenticatedLayout from "../Layout/AuthenticatedLayout";
import AllBatches from "../pages/BatchManagement/AllBatches";
import MyBatches from "../pages/BatchManagement/MyBatches";
import TermsCondition from "../pages/Policy/TermsCondition";
import PrivacyPolicy from "../pages/Policy/PrivacyPolicy";
import CookiePolicy from "../pages/Policy/CookiePolicy";
import Contact from "../pages/Support/Contact";
import Ticket from "../pages/Support/Ticket";
import AllCourses from "../pages/CourseManagement/AllCourses";
import MyCourses from "../pages/CourseManagement/MyCourses";
function AuthenticatedRoutes() {
  return (
    <Routes>
      <Route element={<AuthenticatedLayout />}>
        <Route path="/" element={<Dashboard />} />
        {/* Batch Management */}
        <Route path="/explore-batches" element={<AllBatches />} />
        <Route path="/my-batches" element={<MyBatches />} />
         {/* Course Management */}
        <Route path="/explore-courses" element={<AllCourses />} />
        <Route path="/my-courses" element={<MyCourses />} />
        {/* Support */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/ticket" element={<Ticket />} />
        {/* Polices */}
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Route>

      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
}

export default AuthenticatedRoutes;
